;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import * as Sentry from '@sentry/nextjs';
import type { AnalyticsApp } from '../posthog/types';

/** Indexed tags for Slack/issue alerts (`show tags` only lists tags, not `user.email`). */
const SLACK_USER_TAGS = ['user_email', 'user_name'] as const;

type UserContextTag = (typeof SLACK_USER_TAGS)[number] | 'organisation_id' | 'app';

export interface IdentifySentryUserOptions {
  app: AnalyticsApp;
  id: number | string;
  email: string | null | undefined;
  firstName?: string | null;
  lastName?: string | null;
  organisationId?: number | null;
}

/** Match `Sentry.setTag` / `Sentry.setUser` (isolation scope on server). */
function userContextScope(): Sentry.Scope {
  return Sentry.getIsolationScope();
}

export function identifySentryUser({
  app,
  id,
  email,
  firstName,
  lastName,
  organisationId,
}: IdentifySentryUserOptions): void {
  const normalizedEmail = email?.trim();
  if (!normalizedEmail) {
    resetSentryUser();
    return;
  }

  const name = [firstName?.trim(), lastName?.trim()].filter(Boolean).join(' ') || undefined;
  const scope = userContextScope();

  scope.setUser({
    id: String(id),
    email: normalizedEmail,
    username: name ?? normalizedEmail,
    ...(name ? { name } : {}),
  });

  scope.setTag('app', app);
  scope.setTag('user_email', normalizedEmail);
  if (name) {
    scope.setTag('user_name', name);
  } else {
    clearSentryUserTag('user_name');
  }
  if (organisationId != null) {
    scope.setTag('organisation_id', String(organisationId));
  } else {
    clearSentryUserTag('organisation_id');
  }
}

function clearSentryUserTag(tag: UserContextTag): void {
  userContextScope().setTag(tag, undefined);
}

export function resetSentryUser(): void {
  const scope = userContextScope();
  scope.setUser(null);
  for (const tag of SLACK_USER_TAGS) {
    scope.setTag(tag, undefined);
  }
  scope.setTag('organisation_id', undefined);
}
